export const AI_GENERATORS = ["Midjourney", "DALL-E", "Stable Diffusion", "Firefly", "Runway"];
export const EDITORS = ["Photoshop", "Lightroom", "Snapseed", "Canva"];

export const PHONE_BRANDS = [
  'Apple', 'Samsung', 'Google', 'Huawei', 'Xiaomi', 'Oppo', 'Vivo', 
  'OnePlus', 'Sony Mobile', 'Motorola', 'Realme'
];

export const CAMERA_BRANDS = [
  'Canon', 'Nikon', 'Sony', 'Fujifilm', 'Panasonic', 'Olympus', 
  'Leica', 'Hasselblad', 'Pentax', 'Sigma'
];

export const AI_RESOLUTION_SIGNATURES = [
  '1024x1024', '512x512', '768x768', '1152x896', '896x1152', 
  '1216x832', '832x1216', '1344x768', '768x1344', '1456x816', '816x1456'
];